var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSchedulesGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 88 58"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.747 8.507h44.694c1.726 0 3.125 1.4 3.125 3.125v43.085c0 1.726-1.4 3.125-3.125 3.125H39.747a3.125 3.125 0 01-3.125-3.125V11.632c0-1.726 1.4-3.125 3.125-3.125z",
    fill: "#6BC6C4",
    fillRule: "nonzero",
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.901 7.151H38.326c-.845 0-1.655.333-2.252.926a3.152 3.152 0 00-.932 2.237v43.01c0 .839.335 1.643.932 2.236a3.195 3.195 0 002.252.926h44.576c.845 0 1.654-.333 2.251-.926a3.152 3.152 0 00.932-2.236V10.313c0-1.747-1.426-3.162-3.184-3.162z",
    stroke: "#0E1932",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0E1932",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M41.509 44.468h6.368v6.325h-6.368zM41.509 33.716h6.368v6.325h-6.368zM41.509 22.33h6.368v6.325h-6.368zM52.334 44.468h6.368v6.325h-6.368zM52.334 33.716h6.368v6.325h-6.368zM52.334 22.33h6.368v6.325h-6.368zM63.16 44.468h6.368v6.325H63.16zM63.16 33.716h6.368v6.325H63.16zM63.16 22.33h6.368v6.325H63.16zM73.986 33.716h6.368v6.325h-6.368zM73.986 22.33h6.368v6.325h-6.368z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0E1932",
    strokeWidth: 1.875,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M67.33 1.91h7.995V12.43H67.33z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0E1932",
    strokeWidth: 0.781,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M66.136 12.423H76.52"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0E1932",
    strokeWidth: 1.875,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M45.903 1.91h7.995V12.43h-7.995z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0E1932",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M44.71 12.423h10.383M35.142 15.694h50.944"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.975 24.608l-21.815.042c-5.673.011-10.326 4.65-10.317 10.285.011 5.635 4.682 10.257 10.356 10.248l21.815-.042c5.673-.011 10.326-4.65 10.317-10.285-.011-5.637-4.683-10.259-10.356-10.248z",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.09 25.74l-21.814.042c-5.674.011-10.327 4.65-10.317 10.285.009 5.636 4.681 10.257 10.355 10.248l21.815-.042c5.674-.01 10.327-4.65 10.317-10.285-.009-5.635-4.681-10.258-10.355-10.247zm-.727 17.328c-3.928.007-7.118-3.15-7.126-7.051-.007-3.902 3.171-7.07 7.099-7.078 3.928-.008 7.119 3.149 7.127 7.05a7.036 7.036 0 01-2.072 5.002 7.132 7.132 0 01-5.028 2.077z",
    fill: "#6BC6C4",
    fillRule: "nonzero",
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.247 41.935c-3.928.007-7.119-3.15-7.126-7.051-.008-3.902 3.17-7.07 7.099-7.079 3.928-.007 7.118 3.15 7.126 7.05a7.036 7.036 0 01-2.072 5.002 7.132 7.132 0 01-5.027 2.078h0z",
    stroke: "#0E1932",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.975 24.608l-21.815.042c-5.673.011-10.326 4.65-10.317 10.285h0C1.854 40.57 6.525 45.192 12.2 45.183l21.815-.042c5.673-.011 10.326-4.65 10.317-10.285h0c-.011-5.637-4.683-10.259-10.356-10.248z",
    stroke: "#0E1932",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.71 37.011a1.777 1.777 0 01-.705-.759 2.823 2.823 0 010-2.31c.153-.317.4-.58.706-.756a2.343 2.343 0 012.165 0c.305.177.55.44.703.756.33.735.33 1.575 0 2.31-.154.317-.4.581-.706.759a2.325 2.325 0 01-2.156 0h-.006zm2-.759c.22-.27.33-.656.33-1.157 0-.5-.11-.886-.33-1.158a1.256 1.256 0 00-1.839 0c-.22.267-.33.651-.33 1.153s.11.888.33 1.157a1.25 1.25 0 001.839 0v.005zM17.63 32.974h.73v4.248h-.587l-2.289-2.965v2.965h-.727v-4.248h.581l2.29 2.958z",
    fill: "#0E1932",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 0.781,
    fill: "#000",
    fillRule: "nonzero",
    d: "M40.375 43.7l-6.647-5.8v8.792l2.422-1.757 1.716 3.832 1.33-.588-1.716-3.832z"
  }))));
}

export default __webpack_public_path__ + "static/schedules-green.d419f2b3.svg";
export { SvgSchedulesGreen as ReactComponent };